import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'textArea', 'form', 'modal', 'existingContent' ]
  static values = {}

  modal = null;

  connect() {
    // console.log("Hello, Editorial Guidelines Controller here!", this.element);
    this.modal = new bootstrap.Modal(this.modalTarget);
  }

  copyGuidelines(event) {
    // console.log('Copying guidelines');
    // console.log(event.params);

    const guidelinesId = event.params.guidelinesId;
    const guidelinesContent = this.existingContentTargets.find(target => parseInt(target.dataset.guidelinesId) === parseInt(guidelinesId)).innerText;
    this.textAreaTarget.value = guidelinesContent;

    this.modal.hide();
  }
}
